import { SET_BUSINESS_UUID, SET_IS_LOADING, SET_TOKENS, CLEAR_TOKEN } from './constants';

export const setIsLoading = isLoading => ({
  type: SET_IS_LOADING,
  payload: isLoading
});

export const setBusinessUuid = businessUuid => ({
  type: SET_BUSINESS_UUID,
  payload: businessUuid
});

export const setTokens = tokens => ({
  type: SET_TOKENS,
  payload: tokens
});

export const clearToken = () => ({
  type: CLEAR_TOKEN
});